const formatPhoneNumber = (value: string) => {
  // Remove non-digit characters
  const digits = value.replace(/\D/g, "");

  // Format the digits as 111-111-1111
  if (digits.length <= 3) {
    return digits;
  } else if (digits.length <= 6) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  } else {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }
};

export default formatPhoneNumber;
